module.exports = __webpack_public_path__ + "img/612596459.37173c52.jpg";